import React, { useRef, useState, useEffect, useMemo } from "react";
import axios from "axios";
import ParivahanRCView from "../../Screens/Common/ParivahanRc";
import ParivahanRC2View from "../../Screens/Common/ParivahaanRc2";
import SmartRCView from "../../Screens/Common/SmartRc";
import DigiLockerRCView from "../../Screens/Common/DigiLockerRC";
import PortalModal from "../PortalModal";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { toast } from "react-toastify";

import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

// For generating QR base64 for PDF
import * as QRCodeLib from "qrcode";
import Front from "../../Assets/Logos/Front.png";
import Back from "../../Assets/Logos/Back.png";
import logo from "../../Assets/Logos/ashok1.png";
import { stateCodesMap } from "../../utils/stateCodes";

const getBase64 = (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.setAttribute("crossOrigin", "anonymous");
    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);
      const dataURL = canvas.toDataURL("image/png");
      resolve(dataURL);
    };
    img.onerror = (error) => reject(error);
    img.src = url;
  });
};

pdfMake.vfs = pdfFonts.pdfMake ? pdfFonts.pdfMake.vfs : pdfFonts.vfs;

pdfMake.vfs = pdfFonts.vfs;

export default function RCMasked() {
  const [vehicleNo, setVehicleNo] = useState("");
  const [selectedRC, setSelectedRC] = useState("smartrclite");
  const [submitted, setSubmitted] = useState(true);
  const [rcHistory, setRcHistory] = useState([]);
  const [allRcHistory, setAllRcHistory] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [error, setError] = useState("");
  const [rcPrices, setRcPrices] = useState({
    parivaanrclite: 0,
    parivaanrc2lite: 0,
    smartrclite: 0,
    digilockerrclite: 0,
  });
  const [rcAccess, setRcAccess] = useState({
    parivaanrclite: false,
    parivaanrc2lite: false,
    smartrclite: false,
    digilockerrclite: false,
  });
  const [filters, setFilters] = useState({
    search: "",
    status: "",
    fromDate: "",
    toDate: "",
  });
  const itemsPerPage = 10;

  const [rcData, setRcData] = useState(null);

  const printRef = useRef(null);

  useEffect(() => {
    fetchRcData();
  }, []);

  const [isAccessLoading, setIsAccessLoading] = useState(true);

  const fetchRcData = async () => {
    try {
      setIsAccessLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/services/access-check`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );
      const access = response.data?.serviceAccess || [];
      const prices = response.data?.servicePrices || {};

      setRcAccess({
        parivaanrclite: access.includes("parivaanrclite"),
        parivaanrc2lite: access.includes("parivaanrc2lite"),
        smartrclite: access.includes("smartrclite"),
        digilockerrclite: access.includes("digilockerrclite"),
      });

      setRcPrices({
        parivaanrclite: prices.parivaanrclite || 0,
        parivaanrc2lite: prices.parivaanrc2lite || 0,
        smartrclite: prices.smartrclite || 0,
        digilockerrclite: prices.digilockerrclite || 0,
      });

      console.log("RC Access Set:", access);
    } catch (e) {
      console.error("Error fetching access data:", e);
      toast.error("Failed to load service access information");
    } finally {
      setIsAccessLoading(false);
    }
  };

  const fetchHistoryData = async () => {
    try {
      const endpoints = [
        "rc-parivaanrclite",
        "rc-parivaanrc2lite",
        "rc-smartrclite",
        "rc-digilockerrclite",
      ];

      const responses = await Promise.all(
        endpoints.map((endpoint) =>
          axios.get(
            `${process.env.REACT_APP_API_URL}/services/get-document-records?service=${endpoint}`,
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            },
          ),
        ),
      );

      let combined = responses.flatMap((res, idx) => {
        const data = res.data || [];
        return data.map((item) => ({
          id: item._id,
          service: endpoints[idx],
          vehicleNo: item.idNumber || " ",
          documentType: item.documentType || " ",
          date: item.createdAt || new Date(),
          status: item.status || "pending",
          amount: item.amountDeducted ?? 0,
        }));
      });

      const seen = new Set();
      const unique = combined.filter((item) => {
        const key = `${item.vehicleNo}-${item.date}`;
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });

      unique.sort((a, b) => new Date(b.date) - new Date(a.date));

      setAllRcHistory(unique);
      setRcHistory(unique);
    } catch (err) {
      console.error("Error fetching RC history:", err);
      toast.error("Failed to fetch RC history");
    }
  };

  useEffect(() => {
    fetchHistoryData();
  }, []);

  const handleSubmit = async () => {
    await fetchRcData();

    if (!vehicleNo.trim()) {
      toast.error("Please enter vehicle number");
      return;
    }
    if (!selectedRC) {
      toast.error("Please select an RC type");
      return;
    }

    setShowConfirmationModal(true);
  };

  const proceedWithApiCall = async () => {
    if (!vehicleNo.trim()) {
      toast.error("Please enter vehicle number");
      return;
    }
    if (!selectedRC) {
      toast.error("Please select an RC type");
      return;
    }

    setIsLoading(true);
    setError("");
    setRcData(null);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/services/rc/rclite-full-verification`,
        {
          id_number: vehicleNo,
          rc_type: selectedRC,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        },
      );

      if (response.data.success === false) {
        throw new Error(response.data.message || "Failed to fetch RC data");
      }

      const fetchedData = response.data.data;
      setRcData(fetchedData);
      console.log("RC Data:", fetchedData);
      setSubmitted(true);

      const newEntry = {
        date: new Date().toLocaleString(),
        vehicleNo,
        documentType: selectedRC,
        name: fetchedData?.owner_name || " ",
        details: fetchedData?.maker_model || " ",
        status: "Success",
      };
      setRcHistory((prev) => [newEntry, ...prev]);

      toast.success(
        "RC data fetched successfully.\nPlease wait for PDF download...",
      );
      setShowConfirmationModal(false);

      // Directly generate and download PDF
      await generateAndDownloadPDF(fetchedData);
    } catch (err) {
      console.error("Error fetching RC data:", err);

      let errorMessage = "Failed to fetch RC data. Please try again.";
      if (err.response) {
        if (err.response.data && err.response.data.message) {
          errorMessage = err.response.data.message;
        } else if (err.response.status === 401) {
          errorMessage = "Unauthorized - Please login again";
        } else if (err.response.status === 403) {
          errorMessage = "Forbidden - You don't have permission";
        } else if (err.response.status === 404) {
          errorMessage = "Service not found";
        } else if (err.response.status === 500) {
          errorMessage = "Server error - Please try again later";
        }
      } else if (err.request) {
        errorMessage = "Network error - Please check your connection";
      }

      toast.error(errorMessage);

      const newEntry = {
        date: new Date().toLocaleString(),
        vehicleNo,
        name: "N/A",
        details: "Failed to fetch",
        status: "Failed",
        error: errorMessage,
      };
      setRcHistory((prev) => [newEntry, ...prev]);
      setShowConfirmationModal(false);
    } finally {
      setIsLoading(false);
    }
  };

  const generateAndDownloadPDF = async (data) => {
    if (!data) {
      toast.error("No data available for PDF generation");
      toast.success(
        "RC data fetched successfully.\nPlease wait for PDF download...",
      );
      return;
    }

    if (selectedRC === "smartrclite") {
      // For smartrclite, use pdfmake (no DOM needed)
      try {
        const [frontImg, backImg, logoImg] = await Promise.all([
          getBase64(Front),
          getBase64(Back),
          getBase64(logo),
        ]);
        const stateCode =
          data?.rc_number?.trim().slice(0, 2).toUpperCase() || "";
        const stateName = stateCodesMap[stateCode] || "";

        const qrLines = [
          `State Name: ${data?.state_name || stateName || ""}`,
          `Office Name: ${data?.office_name || ""}`,
          `Vehicle Registration Number: ${data?.rc_number || ""}`,
          `Chassis Number: ${data?.vehicle_chasi_number || ""}`,
          `Engine Number: ${data?.vehicle_engine_number || ""}`,
          `Seating Capacity: ${data?.seating_capacity || ""}`,
          `Standing Capacity: ${data?.standing_capacity || ""}`,
          `Sleeper Capacity: ${data?.sleeper_capacity || ""}`,
          `Owner Name: ${data?.owner_name || ""}`,
          `Laden Weight: ${data?.vehicle_gross_weight || ""}`,
          `Unladen Weight: ${data?.vehicle_unladen_weight || ""}`,
          `Father's Name: ${data?.father_name || ""}`,
          `Registration From Date: ${data?.registration_date || ""}`,
          `Registration Upto Date: ${data?.fit_up_to || ""}`,
          `Address: ${data?.present_address || ""}`,
        ];
        const qrText = qrLines.join(" | ");
        const qrDataUrl = await QRCodeLib.toDataURL(qrText, {
          width: 200,
          margin: 0,
          color: {
            dark: "#000000",
            light: "#0000",
          },
        });

        const createCircleImage = async (text, bgColor) => {
          const canvas = document.createElement("canvas");
          canvas.width = 40;
          canvas.height = 40;
          const ctx = canvas.getContext("2d");

          ctx.beginPath();
          ctx.arc(20, 20, 18, 0, 2 * Math.PI);
          ctx.fillStyle = bgColor;
          ctx.fill();
          ctx.strokeStyle = "#000000";
          ctx.lineWidth = 2;
          ctx.stroke();

          ctx.fillStyle = "#000000";
          ctx.font = "bold 20px Arial";
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillText(text, 20, 20);

          return canvas.toDataURL("image/png");
        };

        const ntCircle = await createCircleImage("NT", "#7dd3fc");
        const stateCircle = await createCircleImage(stateCode, "#fb923c");
        const ownerCircle = await createCircleImage(
          data?.owner_number || "1",
          "#ffffff",
        );

        const createRotatedTextImage = (
          text,
          font = "Arial",
          fontSize = 9,
          padding = 8,
        ) => {
          const scale = window.devicePixelRatio
            ? Math.max(2, window.devicePixelRatio)
            : 2;

          const measureCanvas = document.createElement("canvas");
          const mctx = measureCanvas.getContext("2d");
          mctx.font = `${fontSize}px ${font}`;
          const metrics = mctx.measureText(text);
          const textWidth = Math.ceil(metrics.width);
          const textHeight = Math.ceil(fontSize);

          const cssWidth = textHeight + padding * 2;
          const cssHeight = textWidth + padding * 2;

          const canvas = document.createElement("canvas");
          canvas.width = cssWidth * scale;
          canvas.height = cssHeight * scale;

          const ctx = canvas.getContext("2d");
          ctx.scale(scale, scale);
          ctx.translate(cssWidth / 2, cssHeight / 2);
          ctx.rotate(-Math.PI / 2);

          ctx.font = `${fontSize}px ${font}`;
          ctx.textAlign = "center";
          ctx.textBaseline = "middle";
          ctx.fillStyle = "#000";
          ctx.fillText(text, 0, 0);

          return canvas.toDataURL("image/png");
        };

        const cardIssueImg = createRotatedTextImage(
          `Card Issue Date: (${data?.permit_issue_date || "2025-07-25"})`,
        );
        const form23AImg = createRotatedTextImage("Form 23A");

        const docDefinition = {
          pageSize: { width: 595, height: 420 },
          pageMargins: [20, 20, 20, 20],
          content: [
            {
              columns: [
                {
                  width: 265,
                  stack: [
                    {
                      image: frontImg,
                      width: 265,
                      height: 167,
                      absolutePosition: { x: 15, y: 15 },
                    },
                    {
                      image: logoImg,
                      width: 21,
                      height: 38,
                      absolutePosition: { x: 20, y: 20 },
                    },
                    {
                      stack: [
                        {
                          text: "Indian Union Vehicle Registration Certificate",
                          bold: true,
                          fontSize: 7.5,
                          lineHeight: 1,
                        },
                        {
                          text: `Issued by Government of ${stateName}`,
                          bold: true,
                          fontSize: 7.5,
                          lineHeight: 1,
                          margin: [0, 1, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 65, y: 25 },
                    },
                    {
                      columns: [
                        { image: ntCircle, width: 15, height: 15 },
                        {
                          image: stateCircle,
                          width: 15,
                          height: 15,
                          margin: [2, 0, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 240, y: 25 },
                    },
                    {
                      columns: [
                        {
                          stack: [
                            {
                              text: "Regn No",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                            },
                            {
                              text: data?.rc_number || "",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                              margin: [0, 1, 0, 0],
                            },
                          ],
                          width: 50,
                        },
                        {
                          stack: [
                            {
                              text: "Date of Regn.",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                            },
                            {
                              text: data?.registration_date || "",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                              margin: [0, 1, 0, 0],
                            },
                          ],
                          width: 55,
                        },
                        {
                          stack: [
                            {
                              text: "Regn. Validity",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                            },
                            {
                              text: data?.fit_up_to || "",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                              margin: [0, 1, 0, 0],
                            },
                          ],
                          width: 50,
                        },
                        {
                          stack: [
                            {
                              text: "Owner",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                            },
                            {
                              text: "Serial",
                              fontSize: 6,
                              bold: true,
                              lineHeight: 1,
                              margin: [0, 1, 0, 0],
                            },
                          ],
                          width: 30,
                        },
                        {
                          image: ownerCircle,
                          width: 15,
                          height: 15,
                          margin: [0, 0, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 50 },
                    },
                    {
                      stack: [
                        {
                          text: "Chassis No",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.vehicle_chasi_number || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 67 },
                    },
                    {
                      stack: [
                        {
                          text: "Engine/Motor No",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.vehicle_engine_number || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 84 },
                    },
                    {
                      stack: [
                        {
                          text: "Owner Name",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.owner_name || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 100 },
                    },
                    {
                      stack: [
                        {
                          text: "Son/Wife/Daughter of (In case of Individual Owner)",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.father_name || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 116 },
                    },
                    {
                      stack: [
                        {
                          text: "Ownership",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: "INDIVIDUAL",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 75, y: 130 },
                    },
                    {
                      absolutePosition: { x: 75, y: 146 },
                      stack: [
                        {
                          text: "Address",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          table: {
                            widths: [180],
                            body: [
                              [
                                {
                                  text: data?.present_address || "",
                                  fontSize: 5.5,
                                  lineHeight: 1.15,
                                  border: [false, false, false, false],
                                },
                              ],
                            ],
                          },
                          layout: {
                            hLineWidth: function () {
                              return 0;
                            },
                            vLineWidth: function () {
                              return 0;
                            },
                            paddingLeft: function () {
                              return 0;
                            },
                            paddingRight: function () {
                              return 2;
                            },
                            paddingTop: function () {
                              return 0;
                            },
                            paddingBottom: function () {
                              return 0;
                            },
                          },
                        },
                      ],
                    },
                    {
                      stack: [
                        {
                          text: "Fuel",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.fuel_type || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 20, y: 146 },
                    },
                    {
                      stack: [
                        {
                          text: "Emission Norms",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.norms_type || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 0.5, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 20, y: 163 },
                    },
                    {
                      image: cardIssueImg,
                      width: 18,
                      height: 90,
                      absolutePosition: { x: 260, y: 75 },
                    },
                  ],
                },
                {
                  width: 265,
                  stack: [
                    {
                      image: backImg,
                      width: 265,
                      height: 167,
                      absolutePosition: { x: 305, y: 15 },
                    },
                    {
                      columns: [
                        { image: ntCircle, width: 15, height: 15 },
                        {
                          image: stateCircle,
                          width: 15,
                          height: 15,
                          margin: [2, 0, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 310, y: 23 },
                    },
                    {
                      text: [
                        { text: "Vehicle Class: ", bold: true, fontSize: 7 },
                        {
                          text: `${data?.vehicle_category || " "}`,
                          fontSize: 7,
                        },
                      ],
                      absolutePosition: { x: 350, y: 28 },
                    },
                    {
                      stack: [
                        {
                          text: "Regn. No",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.rc_number || "",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                          margin: [0, 1, 0, 3],
                        },
                      ],
                      absolutePosition: { x: 310, y: 48 },
                    },
                    {
                      image: qrDataUrl,
                      width: 70,
                      height: 70,
                      absolutePosition: { x: 310, y: 65 },
                    },
                    {
                      stack: [
                        {
                          text: "Month-Year of Mfg.",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.manufacturing_date || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 1, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 310, y: 140 },
                    },
                    {
                      text: [
                        { text: "No. of Cylinders ", bold: true, fontSize: 6 },
                        { text: data?.no_cylinders || "", fontSize: 6 },
                      ],
                      absolutePosition: { x: 310, y: 160 },
                    },
                    // {
                    //   text: [
                    //     { text: "No of Axle ", bold: true, fontSize: 6 },
                    //     { text: noOfAxle.toString(), fontSize: 6 },
                    //   ],
                    //   absolutePosition: { x: 310, y: 169 },
                    // },
                    // Right side details
                    {
                      stack: [
                        {
                          text: "Maker:",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.maker_description || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 1, 0, 2],
                        },
                      ],
                      absolutePosition: { x: 390, y: 48 },
                    },
                    {
                      stack: [
                        {
                          text: "Model :",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.maker_model || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 1, 0, 2],
                        },
                      ],
                      absolutePosition: { x: 390, y: 63 },
                    },
                    {
                      columns: [
                        {
                          width: 60,
                          stack: [
                            {
                              text: "Color:",
                              bold: true,
                              fontSize: 6,
                              lineHeight: 1,
                            },
                            {
                              text: data?.color || "",
                              fontSize: 6,
                              lineHeight: 1,
                            },
                          ],
                        },
                        {
                          width: 80,
                          stack: [
                            {
                              text: "/ Body Type:",
                              bold: true,
                              fontSize: 6,
                              lineHeight: 1,
                            },
                            {
                              text: "/" + data?.body_type || "",
                              fontSize: 6,
                              lineHeight: 1,
                            },
                          ],
                        },
                      ],
                      absolutePosition: { x: 390, y: 78 },
                    },
                    {
                      columns: [
                        {
                          width: 100,
                          stack: [
                            {
                              text: "Seating (in all) Capacity",
                              bold: true,
                              fontSize: 6,
                            },
                            { text: data?.seat_capacity || "", fontSize: 6 },
                          ],
                        },
                        //   {
                        //     width: 40,
                        //     stack: [
                        //       { text: "/ Standing ", bold: true, fontSize: 6 },
                        //       {
                        //         text: "/" + data?.standing_capacity || "",
                        //         fontSize: 6,
                        //       },
                        //     ],
                        //   },
                        //   {
                        //     width: 60,
                        //     stack: [
                        //       {
                        //         text: "/ Sleeper capacity",
                        //         bold: true,
                        //         fontSize: 6,
                        //       },
                        //       {
                        //         text: "/" + data?.sleeper_capacity || "",
                        //         fontSize: 6,
                        //       },
                        //     ],
                        //   }
                      ],
                      absolutePosition: { x: 390, y: 93 },
                    },
                    {
                      columns: [
                        // {
                        //   width: 30,
                        //   stack: [
                        //     { text: "Unladen:", bold: true, fontSize: 6 },
                        //     { text: data?.unladen_weight || "", fontSize: 6 },
                        //   ],
                        // },
                        {
                          width: 100,
                          stack: [
                            {
                              text: "Laden/Unladen Weight (kg)",
                              bold: true,
                              fontSize: 6,
                            },
                            {
                              text: data?.vehicle_gross_weight || "",
                              fontSize: 6,
                            },
                          ],
                        },
                        // {
                        //   width: 100,
                        //   stack: [
                        //     {
                        //       text: "/ Gross Combined Weight (kg)",
                        //       bold: true,
                        //       fontSize: 6,
                        //     },
                        //     {
                        //       text: "/" + data?.gross_combination_weight || "",
                        //       fontSize: 6,
                        //     },
                        //   ],
                        // },
                      ],
                      absolutePosition: { x: 390, y: 107 },
                    },
                    {
                      columns: [
                        {
                          width: 35,
                          stack: [
                            { text: "Cubic Cap.", bold: true, fontSize: 6 },
                            { text: data?.cubic_capacity || "", fontSize: 6 },
                          ],
                        },
                        {
                          width: 70,
                          stack: [
                            {
                              text: "/ Horse Power (BHP/Kw) ",
                              bold: true,
                              fontSize: 6,
                            },
                            {
                              text: "/" + data?.horse_power || "",
                              fontSize: 6,
                            },
                          ],
                        },
                        {
                          width: 60,
                          stack: [
                            {
                              text: "/ Wheel Base (mm) ",
                              bold: true,
                              fontSize: 6,
                            },
                            { text: "/" + data?.wheelbase || "", fontSize: 6 },
                          ],
                        },
                      ],
                      absolutePosition: { x: 390, y: 121 },
                    },
                    {
                      stack: [
                        {
                          text: "Financier",
                          fontSize: 6,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.financer || "",
                          fontSize: 6,
                          lineHeight: 1,
                          margin: [0, 1, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 390, y: 135 },
                    },
                    {
                      stack: [
                        {
                          text: "Registration Authority",
                          fontSize: 5.5,
                          bold: true,
                          lineHeight: 1,
                        },
                        {
                          text: data?.registered_at || "",
                          fontSize: 5.5,
                          lineHeight: 1,
                          margin: [0, 1, 0, 0],
                        },
                      ],
                      absolutePosition: { x: 485, y: 159 },
                    },
                    {
                      image: form23AImg,
                      width: 15,
                      height: 50,
                      absolutePosition: { x: 555, y: 85 },
                    },
                  ],
                },
              ],
            },
          ],
        };

        pdfMake
          .createPdf(docDefinition)
          .download(`RCLite-${data?.rc_number || "RCLite"}.pdf`);
        // toast.success("PDF downloaded successfully");
      } catch (error) {
        console.error("Error generating PDF:", error);
        toast.error("Failed to generate PDF. Please try again.");
      }
    } else {
      // For non-smartrclite types (parivaanrclite, parivaanrc2lite, digilockerrclite)
      // Need to temporarily render the component offscreen to capture it
      await renderAndCapturePDF(data);
    }
  };

  const renderAndCapturePDF = async (data) => {
    // Create a temporary hidden container
    const tempContainer = document.createElement("div");
    tempContainer.style.position = "absolute";
    tempContainer.style.left = "-9999px";
    tempContainer.style.top = "-9999px";
    document.body.appendChild(tempContainer);

    try {
      // Dynamically import React and ReactDOM
      const React = await import("react");
      const ReactDOM = await import("react-dom");

      // Render the appropriate component based on selectedRC
      let ComponentToRender;
      if (selectedRC === "parivaanrclite") {
        ComponentToRender = ParivahanRCView;
      } else if (selectedRC === "parivaanrc2lite") {
        ComponentToRender = ParivahanRC2View;
      } else if (selectedRC === "digilockerrclite") {
        ComponentToRender = DigiLockerRCView;
      }

      if (ComponentToRender) {
        ReactDOM.render(
          React.createElement(ComponentToRender, { data }),
          tempContainer,
        );

        // Wait for rendering to complete
        await new Promise((resolve) => setTimeout(resolve, 500));

        // Capture the rendered element
        const canvas = await html2canvas(tempContainer.firstChild, {
          scale: 3,
          useCORS: true,
          backgroundColor: "#ffffff",
        });

        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("portrait", "pt", "a4");
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;
        const ratio = Math.min(pageWidth / imgWidth, pageHeight / imgHeight);
        const scaledWidth = imgWidth * ratio;
        const scaledHeight = imgHeight * ratio;
        const marginX = (pageWidth - scaledWidth) / 2;
        const marginY = 30;

        pdf.addImage(
          imgData,
          "PNG",
          marginX,
          marginY,
          scaledWidth,
          scaledHeight,
        );
        pdf.save(`RC-${vehicleNo}.pdf`);
        toast.success("PDF downloaded successfully");

        // Cleanup
        ReactDOM.unmountComponentAtNode(tempContainer);
      }
    } catch (err) {
      console.error("Error generating PDF:", err);
      toast.error("Failed to generate PDF. Please try again.");
    } finally {
      // Remove temporary container
      document.body.removeChild(tempContainer);
    }
  };

  const paginatedData = Array.isArray(rcHistory)
    ? rcHistory.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage,
      )
    : [];

  const totalPages = Math.ceil(
    Array.isArray(rcHistory) ? rcHistory.length / itemsPerPage : 0,
  );

  const handlePrev = () => setCurrentPage((prev) => Math.max(prev - 1, 1));
  const handleNext = () =>
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));

  const applyFilters = () => {
    let filteredData = [...allRcHistory];

    if (filters.search) {
      const searchTerm = filters.search.toLowerCase();
      filteredData = filteredData.filter((item) =>
        item.vehicleNo.toLowerCase().includes(searchTerm),
      );
    }

    if (filters.status) {
      filteredData = filteredData.filter(
        (item) => item.status.toLowerCase() === filters.status.toLowerCase(),
      );
    }

    if (filters.fromDate || filters.toDate) {
      const fromDate = filters.fromDate ? new Date(filters.fromDate) : null;
      const toDate = filters.toDate ? new Date(filters.toDate) : null;

      filteredData = filteredData.filter((item) => {
        const itemDate = new Date(item.date);
        let matches = true;

        if (fromDate && itemDate < fromDate) matches = false;
        if (toDate && itemDate > toDate) matches = false;

        return matches;
      });
    }

    setRcHistory(filteredData);
    setCurrentPage(1);
  };

  const clearFilters = () => {
    setFilters({
      search: "",
      status: "",
      fromDate: "",
      toDate: "",
    });
    setRcHistory(allRcHistory);
    setCurrentPage(1);
  };

  useEffect(() => {
    applyFilters();
  }, [filters, allRcHistory]);

  const visiblePages = useMemo(() => {
    const delta = 2;
    const pages = [];
    for (
      let i = Math.max(1, currentPage - delta);
      i <= Math.min(totalPages, currentPage + delta);
      i++
    ) {
      pages.push(i);
    }
    return pages;
  }, [currentPage, totalPages]);

  return (
    <>
      <div className="py-4 w-full mx-auto print:bg-white">
        <div className="w-full mx-auto md:py-4">
          <div className="bg-blue-100 p-2">
            <h2 className="text-center text-xl font-semibold text-blue-700">
              Registration Certificate Lite
            </h2>
          </div>

          <div className="flex flex-col md:justify-between gap-4 md:flex-row md:items-center pt-6">
            <input
              type="text"
              placeholder="Enter Vehicle No"
              value={vehicleNo}
              onChange={(e) => setVehicleNo(e.target.value)}
              className="w-1/2 border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
            {isAccessLoading ? (
              <div>Loading access options...</div>
            ) : (
              <div className="flex w-full gap-3">
                <div className="w-1/4">
                  <label
                    className={`flex w-full items-center gap-1 ${
                      !rcAccess.parivaanrclite
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    <input
                      type="radio"
                      name="rc"
                      value="parivaanrclite"
                      checked={selectedRC === "parivaanrclite"}
                      disabled={!rcAccess.parivaanrclite}
                      onChange={() => setSelectedRC("parivaanrclite")}
                    />
                    <span>
                      Parivahan RC <br />
                      <span className="text-red-400 text-sm">
                        ₹ {rcPrices.parivaanrclite}
                      </span>
                    </span>
                  </label>
                </div>
                <div className="w-1/4">
                  <label
                    className={`flex w-full items-center gap-1 ${
                      !rcAccess.parivaanrc2lite
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    <input
                      type="radio"
                      name="rc"
                      value="parivaanrc2lite"
                      checked={selectedRC === "parivaanrc2lite"}
                      disabled={!rcAccess.parivaanrc2lite}
                      onChange={() => setSelectedRC("parivaanrc2lite")}
                    />
                    <span>
                      Parivahan RC 2 <br />
                      <span className="text-red-400 text-sm">
                        ₹ {rcPrices.parivaanrc2lite}
                      </span>
                    </span>
                  </label>
                </div>
                <div className="w-1/4">
                  <label
                    className={`flex w-full items-center gap-1 ${
                      !rcAccess.smartrclite
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    <input
                      type="radio"
                      name="rc"
                      value="smartrclite"
                      checked={selectedRC === "smartrclite"}
                      disabled={!rcAccess.smartrclite}
                      onChange={() => setSelectedRC("smartrclite")}
                    />
                    <span>
                      Smart RC <br />
                      <span className="text-red-400 text-sm">
                        ₹ {rcPrices.smartrclite}
                      </span>
                    </span>
                  </label>
                </div>
                <div className="w-1/4">
                  <label
                    className={`flex w-full items-center gap-1 ${
                      !rcAccess.digilockerrclite
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                  >
                    <input
                      type="radio"
                      name="rc"
                      value="digilockerrclite"
                      checked={selectedRC === "digilockerrclite"}
                      disabled={!rcAccess.digilockerrclite}
                      onChange={() => setSelectedRC("digilockerrclite")}
                    />
                    <span>
                      Digilocker RC <br />
                      <span className="text-red-400 text-sm">
                        ₹ {rcPrices.digilockerrclite}
                      </span>
                    </span>
                  </label>
                </div>
              </div>
            )}
          </div>

          <div className="flex justify-start mt-4">
            <button
              onClick={handleSubmit}
              disabled={isLoading || !selectedRC}
              className={`bg-indigo-600 text-white py-2 px-6 rounded hover:bg-indigo-700 ${
                isLoading ? "opacity-70 cursor-not-allowed" : ""
              }`}
            >
              {isLoading ? "Processing..." : "SUBMIT"}
            </button>
          </div>
        </div>

        {showConfirmationModal && (
          <PortalModal>
            <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
              <div className="bg-white rounded-lg shadow-lg w-full max-w-md p-6">
                <h3 className="text-lg font-semibold mb-4">Confirm Payment</h3>
                <p className="mb-4">
                  This RC verification will cost you{" "}
                  <span className="text-red-600">
                    ₹{rcPrices[selectedRC] ?? 10}
                  </span>
                  . Do you want to proceed?
                </p>
                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => setShowConfirmationModal(false)}
                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                  >
                    Cancel
                  </button>
                  <button
                    onClick={proceedWithApiCall}
                    disabled={isLoading}
                    className={`px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 ${
                      isLoading ? "opacity-70 cursor-not-allowed" : ""
                    }`}
                  >
                    {isLoading ? "Processing..." : "Confirm & Pay"}
                  </button>
                </div>
              </div>
            </div>
          </PortalModal>
        )}

        <div className="w-full">
          <div className="bg-white p-4 shadow-md rounded-lg mb-4">
            <h3 className="text-lg font-semibold mb-4">Current RC Results</h3>

            <div className="bg-gray-50 p-4 rounded-lg mb-4">
              <h4 className="text-md font-medium mb-3">
                Filter Current Results
              </h4>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-4">
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Search
                  </label>
                  <input
                    type="text"
                    placeholder="Search vehicle number"
                    value={filters.search}
                    onChange={(e) =>
                      setFilters({ ...filters, search: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    Status
                  </label>
                  <select
                    value={filters.status}
                    onChange={(e) =>
                      setFilters({ ...filters, status: e.target.value })
                    }
                    className="w-full border rounded px-3 py-2"
                  >
                    <option value="">All Status</option>
                    <option value="Success">Success</option>
                    <option value="Failed">Failed</option>
                    <option value="pending">Pending</option>
                  </select>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    value={filters.fromDate}
                    onChange={(e) =>
                      setFilters({ ...filters, fromDate: e.target.value })
                    }
                    className="w-full border rounded px-3 py-2"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">
                    To Date
                  </label>
                  <input
                    type="date"
                    value={filters.toDate}
                    onChange={(e) =>
                      setFilters({ ...filters, toDate: e.target.value })
                    }
                    className="w-full border rounded px-3 py-2"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-2">
                <button
                  onClick={clearFilters}
                  className="px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
                >
                  Clear
                </button>
                <button
                  onClick={applyFilters}
                  className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                >
                  Apply
                </button>
              </div>
            </div>

            {rcHistory.length === 0 ? (
              <div className="text-center py-4">
                No records found matching your filters
              </div>
            ) : (
              <>
                <div className="overflow-x-auto">
                  <table className="w-full table-auto text-sm">
                    <thead className="bg-gray-100">
                      <tr>
                        <th className="px-4 py-2 border">Sl No</th>
                        <th className="px-4 py-2 border">Vehicle No.</th>
                        <th className="px-4 py-2 border">Type</th>
                        <th className="px-4 py-2 border">Date & Time</th>
                        <th className="px-4 py-2 border">Status</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData.map((item, index) => (
                        <tr
                          key={index}
                          className="text-center hover:bg-gray-50"
                        >
                          <td className="px-4 py-2 border">
                            {(currentPage - 1) * itemsPerPage + index + 1}
                          </td>
                          <td className="px-4 py-2 border">{item.vehicleNo}</td>
                          <td className="px-4 py-2 border">
                            {item.documentType}
                          </td>
                          <td className="px-4 py-2 border">
                            {new Date(item.date).toLocaleString()}
                          </td>
                          <td className="px-4 py-2 border">
                            <span
                              className={`px-2 py-1 rounded text-white text-xs ${
                                item.status.toLowerCase() === "success"
                                  ? "bg-green-500"
                                  : "bg-red-500"
                              }`}
                            >
                              {item.status}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="flex flex-col md:flex-row items-center justify-between mt-4">
                  <span className="text-sm text-gray-500">
                    Showing {(currentPage - 1) * itemsPerPage + 1} to{" "}
                    {Math.min(currentPage * itemsPerPage, rcHistory.length)} of{" "}
                    {rcHistory.length} entries
                  </span>

                  <div className="flex gap-2 mt-2 md:mt-0">
                    <button
                      onClick={handlePrev}
                      disabled={currentPage === 1}
                      className="px-3 py-1 border rounded text-sm disabled:opacity-50"
                    >
                      Prev
                    </button>

                    {visiblePages[0] > 1 && <span className="px-2">...</span>}
                    {visiblePages.map((p) => (
                      <button
                        key={p}
                        onClick={() => setCurrentPage(p)}
                        className={`px-3 py-1 border rounded text-sm ${
                          currentPage === p ? "bg-blue-600 text-white" : ""
                        }`}
                      >
                        {p}
                      </button>
                    ))}
                    {visiblePages[visiblePages.length - 1] < totalPages && (
                      <span className="px-2">...</span>
                    )}

                    <button
                      onClick={handleNext}
                      disabled={currentPage === totalPages}
                      className="px-3 py-1 border rounded text-sm disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
